import { render, staticRenderFns } from "./ClientesPorcentagemDevolucao.vue?vue&type=template&id=604ded8e&scoped=true&"
import script from "./ClientesPorcentagemDevolucao.vue?vue&type=script&lang=js&"
export * from "./ClientesPorcentagemDevolucao.vue?vue&type=script&lang=js&"
import style0 from "./ClientesPorcentagemDevolucao.vue?vue&type=style&index=0&id=604ded8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604ded8e",
  null
  
)

export default component.exports